import * as ko from 'knockout';
import entityBase from 'entityBase';

export class wty_cov_type extends entityBase {
    description  : KnockoutObservable<string>;
    warranty_type: KnockoutObservable<string>;
    wty_cov_type : KnockoutObservable<string>;

    constructor(item: any){
        super();
        this.description   = ko.observable(item.description).extend({ maxLength: 256 });
        this.warranty_type = ko.observable(item.warranty_type).extend({ maxLength: 128 });
        this.wty_cov_type  = ko.observable(item.wty_cov_type).extend({ maxLength: 32 });
    }
}


